// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skitterbook-loader-container {
    position: absolute;
    z-index: 1;
    width: fit-content;
    left: 50%;
    top: 10rem;
    transform: translateX(-50%);
}

    .skitterbook-loader-container.loaded {
        display: none;
    }

    .skitterbook-loader-container:not(.reduced) > .ed-container > .ed-content {
        display: flex;
        justify-content: center;
        width: fit-content;
    }

.skitterbook-video-file-loader-container {
    transition: transform ease 500ms, left ease 500ms, 1000ms max-height ease 2500ms, 0ms max-width ease 1500ms;
    max-width: 320px;
    max-height: 256px;
}

.skitterbook-loader-container.reduced .skitterbook-video-file-loader-container {
    left: 0rem;
    top: -1rem;
    transform: translateX(0%);
}

.start-skitterbook-title {
    visibility: visible;
    transition: 500ms opacity ease 0ms, 500ms transform ease 0ms, 500ms max-height ease 0ms, 500ms max-width ease 0ms;
    max-height: 48px;
    font-size: 1.2em;
    font-weight: bold;
}

.start-skitterbook-subtitle {
    visibility: visible;
    transition: 500ms opacity ease 0ms, 500ms transform ease 0ms, 500ms max-height ease 0ms, 500ms max-width ease 0ms;
    max-height: 64px;
}

.skitterbook-loader-container.reduced .start-skitterbook-title {
    opacity: 0;
    transform: translateX(100%);
    max-height: 0px;
    max-width: 32px;
}

.skitterbook-loader-container.reduced .start-skitterbook-subtitle {
    opacity: 0;
    transform: translateX(100%);
    max-height: 0px;
    max-width: 32px;
}

.start-skitterbook-title-content {
    width: fit-content;
    height: fit-content;
}

    .start-skitterbook-title-content:not(.reduced) > svg {
        max-width: 10rem;
        max-height: 10rem;
        transition: 500ms max-width 0ms ease, 500ms max-height 0ms ease;
    }

    .start-skitterbook-title-content.reduced > svg {
        max-width: 5rem;
        max-height: 5rem;
        transition: 500ms max-width 0ms ease, 500ms max-height 0ms ease;
    }
`, "",{"version":3,"sources":["webpack://./src/Skitterbook/css/SkitterBookLoader.css"],"names":[],"mappings":"AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,2BAA2B;AAC/B;;IAEI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,kBAAkB;IACtB;;AAEJ;IACI,2GAA2G;IAC3G,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,iHAAiH;IACjH,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,iHAAiH;IACjH,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,2BAA2B;IAC3B,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,2BAA2B;IAC3B,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;IAEI;QACI,gBAAgB;QAChB,iBAAiB;QACjB,+DAA+D;IACnE;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,+DAA+D;IACnE","sourcesContent":["@import '../../css/App.css';\r\n\r\n.skitterbook-loader-container {\r\n    position: absolute;\r\n    z-index: 1;\r\n    width: fit-content;\r\n    left: 50%;\r\n    top: 10rem;\r\n    transform: translateX(-50%);\r\n}\r\n\r\n    .skitterbook-loader-container.loaded {\r\n        display: none;\r\n    }\r\n\r\n    .skitterbook-loader-container:not(.reduced) > .ed-container > .ed-content {\r\n        display: flex;\r\n        justify-content: center;\r\n        width: fit-content;\r\n    }\r\n\r\n.skitterbook-video-file-loader-container {\r\n    transition: transform ease 500ms, left ease 500ms, 1000ms max-height ease 2500ms, 0ms max-width ease 1500ms;\r\n    max-width: 320px;\r\n    max-height: 256px;\r\n}\r\n\r\n.skitterbook-loader-container.reduced .skitterbook-video-file-loader-container {\r\n    left: 0rem;\r\n    top: -1rem;\r\n    transform: translateX(0%);\r\n}\r\n\r\n.start-skitterbook-title {\r\n    visibility: visible;\r\n    transition: 500ms opacity ease 0ms, 500ms transform ease 0ms, 500ms max-height ease 0ms, 500ms max-width ease 0ms;\r\n    max-height: 48px;\r\n    font-size: 1.2em;\r\n    font-weight: bold;\r\n}\r\n\r\n.start-skitterbook-subtitle {\r\n    visibility: visible;\r\n    transition: 500ms opacity ease 0ms, 500ms transform ease 0ms, 500ms max-height ease 0ms, 500ms max-width ease 0ms;\r\n    max-height: 64px;\r\n}\r\n\r\n.skitterbook-loader-container.reduced .start-skitterbook-title {\r\n    opacity: 0;\r\n    transform: translateX(100%);\r\n    max-height: 0px;\r\n    max-width: 32px;\r\n}\r\n\r\n.skitterbook-loader-container.reduced .start-skitterbook-subtitle {\r\n    opacity: 0;\r\n    transform: translateX(100%);\r\n    max-height: 0px;\r\n    max-width: 32px;\r\n}\r\n\r\n.start-skitterbook-title-content {\r\n    width: fit-content;\r\n    height: fit-content;\r\n}\r\n\r\n    .start-skitterbook-title-content:not(.reduced) > svg {\r\n        max-width: 10rem;\r\n        max-height: 10rem;\r\n        transition: 500ms max-width 0ms ease, 500ms max-height 0ms ease;\r\n    }\r\n\r\n    .start-skitterbook-title-content.reduced > svg {\r\n        max-width: 5rem;\r\n        max-height: 5rem;\r\n        transition: 500ms max-width 0ms ease, 500ms max-height 0ms ease;\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
